import React, { useState, useEffect } from "react";
import { 
    Box,
    Flex,
    Text,
    Grid,
    GridItem,
    List,
    ListItem,
    ListIcon, 
    Icon,
    Button,
    Link,
    Tag  
} from '@chakra-ui/react'
import { 
    ProfileProps, 
    MobileRequirements
} from "../../types";
import { LinkContext } from "../../LinkContext";
import { ReactComponent as BlueLine } from "../../img/blueLine.svg";
import { ReactComponent as BlackLine } from "../../img/blackLine.svg";
import { ReactComponent as TopArrow } from "../../img/topArrow.svg";
import { ReactComponent as BottomArrow } from "../../img/bottomArrow.svg";
  
const TAG_CONTENT = {
    iAA: { color: "#F9B233", tag: "ИД" },
    points100: { color: "#27AE60", tag: "100" },
    noExams: { color: "#27AE60", tag: "БВИ" },
};

const MobileTableItem: React.FC<ProfileProps> = ({ profile }) => {
    const [requirementsArray, setRequirementsArray] = useState<MobileRequirements>();

    useEffect(() => {
        setRequirementsArray({
            noExams: profile.no_exams,
            points100: profile.points100,
            iAA: profile.individual_achievement_advantages
        })
    }, [])


    return(
        <Flex 
            bg='#F4F4F4'
            p='20px'
            gap='10px' 
            borderRadius='4px'
            flexDirection='column'
        >
            <Box>
                Профиль: {profile.name}
            </Box>
            <Flex
                gap='5px'
                flexDirection='column'
                fontSize='14px'
                lineHeight='18px'
            >
                <Box as='b' lineHeight='20px'>
                    Год и уровень:
                </Box>
                <List>
                    {profile.levels.map((level, i) => (
                        <ListItem key={i} py='5px'>
                            <ListIcon as={BlueLine}/>
                            {level.year} - уровень: {level.level}
                        </ListItem>
                    ))}
                </List>
            </Flex>
            <Flex
                gap='10px'
                flexDirection='column'
                fontSize='14px'
                lineHeight='18px'
            >
                <Box as='b' lineHeight='20px'>
                    Условия получения ИД или ВИ:
                </Box>
                <List>
                    {requirementsArray && Object.keys(requirementsArray).map((key) =>
                        requirementsArray[key as keyof MobileRequirements].map((x, index) => (
                            <ListItem key={index} mb={4}>
                                <Flex align="start" gap={4}>
                                    <Box>
                                        <Tag
                                            bgColor={TAG_CONTENT[key as keyof typeof TAG_CONTENT].color}
                                            color="white"
                                            fontWeight="bold"
                                        >
                                            {TAG_CONTENT[key as keyof typeof TAG_CONTENT].tag}
                                        </Tag>
                                        {key === "points100" && (
                                            <Flex flexWrap="wrap" gap={2} mt={2}>
                                                {"subjects" in x && x.subjects.map((subject, index) => (
                                                    <Tag 
                                                        key={index} 
                                                        bgColor="#40B8FC" 
                                                        color="white" 
                                                        fontWeight="bold"
                                                    >
                                                        <Text>
                                                            {subject.slice(0, 3)}
                                                        </Text>
                                                    </Tag>
                                                ))}
                                            </Flex>
                                        )}
                                    </Box>
                                    <Box flex="1">
                                        {(key === "points100" || key === "noExams") && (
                                            <Text fontSize="sm" color="gray.500" mb={2}>
                                                Только по результатам за 9-11 классы
                                            </Text>
                                        )}
                                        <Text>{x.requirements}</Text>
                                    </Box>
                                </Flex>
                            </ListItem>
                        ))
                    )}
                </List>
            </Flex>
        </Flex>
    )
}

export default MobileTableItem;